import { render } from "./CoveragePage.vue?vue&type=template&id=5e44ace0&scoped=true"
import script from "./CoveragePage.vue?vue&type=script&lang=js"
export * from "./CoveragePage.vue?vue&type=script&lang=js"

import "./CoveragePage.vue?vue&type=style&index=0&id=5e44ace0&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e44ace0"]])

export default __exports__